import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "8",
  height: "12",
  fill: "none",
  viewBox: "0 0 8 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M6.9 7.5 4 10.4 1.1 7.5C1 7.4.8 7.3.6 7.3s-.3 0-.5.2c-.1.1-.2.3-.2.5s0 .3.2.5l3.3 3.3s.1.1.2.1h.6s.2 0 .2-.1l3.3-3.3s.1-.1.1-.2v-.6s0-.2-.1-.2c0 0-.1-.1-.2-.1h-.6s-.2 0-.2.1Zm-5.8-3L4 1.6l2.9 2.9s.1.1.2.1h.6s.2 0 .2-.1c0 0 .1-.1.1-.2v-.6s0-.2-.1-.2L4.5.2S4.4.1 4.3.1h-.6s-.2 0-.2.1L.2 3.5c-.1.1-.2.3-.2.5s0 .3.2.5c.1.1.3.2.5.2s.3 0 .5-.2Z"
    }, null, -1)
  ]))]))
}
export default { render: render }